//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { LoginOut } from "@/api/login";
import currentEnv from "../utils/envSetting"; //引入 axios

export default {
  data: function data() {
    return {
      userNames: "",
      toPath: "",
      isLogin: false,
      currentpath: null
    };
  },
  computed: {
    // isLogin () {
    //   return !!this.$store.state.user.sourceType;
    //   // return sessionStorage.getItem("token")
    // },
    userName: function userName() {
      return sessionStorage.getItem("userName");
    }
  },
  watch: {
    // 如果 `question` 发生改变，这个函数就会运行
    $route: function $route(to) {
      // console.log(to);
      this.isLogin = sessionStorage.getItem("token") && sessionStorage.getItem("userName");
      this.toPath = to.path;
    }
  },
  created: function created() {
    this.userNames = sessionStorage.getItem("userName");
    this.isLogin = sessionStorage.getItem("token") && sessionStorage.getItem("userName");
    console.log(this.$route.path);
  },
  methods: {
    myChange: function myChange() {
      this.isLogin = sessionStorage.getItem("token") && sessionStorage.getItem("userName");
    },
    goSupermarket: function goSupermarket(id) {
      this.$router.push({
        path: "/xyd/Supermarket",
        query: {
          id: id
        }
      });
    },
    goLogin: function goLogin(path) {
      if (this.$route.path !== path) this.$router.push(path);
    },
    goPath: function goPath(path) {
      if (this.$route.path !== path) this.$router.push(path);
    },
    loginOut: function loginOut() {
      var _this = this;

      LoginOut().then(function (res) {
        if (res.data.code == 200) {
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("sourceType");
          sessionStorage.removeItem("bankAuth");
          sessionStorage.removeItem("phone");
          sessionStorage.removeItem("userName");
          sessionStorage.removeItem("user");
          sessionStorage.removeItem("currentTab");
          sessionStorage.removeItem("loginTime");

          if (currentEnv == 1) {
            _this.$router.push("/xyd/login"); //测试用

          } else {
            // let paramurl = "http://2.46.5.101:8084/#/xyd/index"; //测试环境
            var paramurl = "https://credit.suzhou.com.cn/#/xyd/index"; //正式环境

            var encodedParam = encodeURIComponent(paramurl);
            window.open("https://sst.suzhou.gov.cn/sst-smartcity-sso/rest/oauth2/logout?redirect_uri=".concat(encodedParam), "_self"); //生产用
            // https://sst.suzhou.gov.cn/sst-smartcity-sso/frame/pages/login/memlogin
            //
          }
        } else {
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("sourceType");
          sessionStorage.removeItem("bankAuth");
          sessionStorage.removeItem("phone");
          sessionStorage.removeItem("userName");
          sessionStorage.removeItem("user");
          sessionStorage.removeItem("currentTab");
          sessionStorage.removeItem("loginTime");

          if (currentEnv == 1) {
            _this.$router.push("/xyd/login"); //测试用

          } else {
            // let paramurl = "http://2.46.5.101:8084/#/xyd/index";
            // let paramurl = "https://credit.suzhou.com.cn/#/xyd/index";
            var _paramurl = "https://credit.suzhou.com.cn/#/xyd/index";

            var _encodedParam = encodeURIComponent(_paramurl);

            window.open("https://sst.suzhou.gov.cn/sst-smartcity-sso/rest/oauth2/logout?redirect_uri=".concat(_encodedParam), "_self");
            console.log("退出"); //生产用
            //  window.open(
            //   `https://sst.suzhou.gov.cn/sst-smartcity-sso/rest/oauth2/logout?redirect_uri=${encodedParam}`,
            //   "_self"
            // );
          }
        }
      }).catch(function (err) {});
    },
    handleSelect: function handleSelect(index) {
      // console.log(index);
      var sourceType = sessionStorage.getItem("sourceType");

      if (index === "/xyd/publicCredit" && (sourceType === "2" || sourceType === "4") || index !== "/xyd/publicCredit") {
        this.goPath(index);
      } else {
        var token = sessionStorage.getItem("token");

        if (token) {
          this.$message.error("本账号暂无权限");
          return;
        } else {
          this.$router.push("/xyd/login");
          return;
        }
      }

      if (index === "/xyd/apply_loan" && sourceType === "1" || index !== "/xyd/apply_loan") {
        this.goPath(index);
        return;
      } else {
        var _token = sessionStorage.getItem("token");

        if (_token && sourceType === "2" || _token && sourceType === "3" || _token && sourceType === "4") {
          this.$message.error("本账号暂无权限");
          this.$router.push(this.toPath);
        } else {
          this.$router.push("/xyd/login");
        }
      }
    }
  }
};